/** "What agents remember about me" (account menu). */
export default {
  en: {
    title: "What agents remember about me",
    subtitle: "Agents only remember things about you, and only use what they remember, when you allow it: an agent you have not allowed cannot read your notes, even ones another agent kept. Here you see everything they keep, by agent, and you can forget any of it. Each change is recorded in the audit trail.",
    menu: "What agents remember about me",
    consents: "Agents allowed to remember",
    consentLine: "{{agent}} — allowed on {{date}}",
    noConsents: "You haven't allowed any agent to remember things about you.",
    stop: "Stop and forget",
    stopAria: "Stop {{agent}} remembering, and forget what it kept",
    stopConfirm: "Stop this agent remembering things about you, and forget what it kept?",
    stopped: "{{agent}} no longer remembers things about you",
    anyAgent: "Any agent",
    saved: "Saved {{date}}",
    empty: "Agents don't remember anything about you.",
    forget: "Forget",
    forgetOne: "Forget this",
    forgetConfirm: "Forget this? It can't be undone.",
    forgetAll: "Forget everything",
    forgetAllConfirm: "Forget everything agents remember about you? It can't be undone.",
    forgotten: "Forgotten",
    forgottenAll: "Everything was forgotten",
    cancel: "Cancel",
    exportCsv: "Download (spreadsheet)",
    exportJson: "Download (JSON)",
  },
  ar: {
    title: "ما يتذكره الوكلاء عني",
    subtitle: "لا يتذكر الوكلاء شيئًا عنك، ولا يستخدمون ما يتذكرونه، إلا إذا سمحت بذلك: لا يستطيع وكيل لم تسمح له قراءة ملاحظاتك، حتى تلك التي احتفظ بها وكيل آخر. هنا ترى كل ما يحتفظون به، مرتبًا حسب الوكيل، ويمكنك محو أي جزء منه. يُسجَّل كل تغيير في سجل التدقيق.",
    menu: "ما يتذكره الوكلاء عني",
    consents: "الوكلاء المسموح لهم بالتذكّر",
    consentLine: "{{agent}} — سُمح له في {{date}}",
    noConsents: "لم تسمح لأي وكيل بتذكّر أشياء عنك.",
    stop: "أوقف وامحُ",
    stopAria: "أوقف تذكّر {{agent}} وامحُ ما احتفظ به",
    stopConfirm: "إيقاف تذكّر هذا الوكيل لأشياء عنك، ومحو ما احتفظ به؟",
    stopped: "لم يعد {{agent}} يتذكر أشياء عنك",
    anyAgent: "أي وكيل",
    saved: "حُفظ في {{date}}",
    empty: "لا يتذكر الوكلاء أي شيء عنك.",
    forget: "امحُ",
    forgetOne: "امحُ هذا",
    forgetConfirm: "محو هذا؟ لا يمكن التراجع عنه.",
    forgetAll: "امحُ كل شيء",
    forgetAllConfirm: "محو كل ما يتذكره الوكلاء عنك؟ لا يمكن التراجع عنه.",
    forgotten: "تم المحو",
    forgottenAll: "تم محو كل شيء",
    cancel: "إلغاء",
    exportCsv: "تنزيل (جدول بيانات)",
    exportJson: "تنزيل (JSON)",
  },
} as const;
